import { action } from "typesafe-actions";

import GeneralActionTypes from "./constants";

export const waitForUrlExists = (url: string, delay: number, callback: () => void) =>
  action(GeneralActionTypes.WAIT_FOR_URL_EXISTS, { url, delay, callback });

export const cancelUrlWaiting = () => action(GeneralActionTypes.CANCEL_URL_WAITING);
